var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "9ao9wfixha",
    d: "M0 0L15 0 15 6 0 6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.615 1.739c.07-.184.138-.368.22-.589.088.082.13.126.177.166l6.722 5.778c.221.19.463.355.764.439.764.21 1.423.057 1.988-.428l6.743-5.8c.046-.039.07-.095.105-.143l.08.03.201.547v10.046c-.051.138-.085.284-.157.414-.351.643-.954.95-1.773.95H2.828c-.127 0-.254.002-.381 0-.822-.02-1.492-.442-1.741-1.095-.034-.089-.06-.18-.09-.27V1.74z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.615 .15)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5l5kp3dnhb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9ao9wfixha"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 .191C.243.068.501.021.77.003.82-.001.87 0 .92 0L14.07 0c.323 0 .628.053.929.187-.051.044-.09.08-.13.113L8.167 5.73c-.44.357-.898.359-1.335.004L.12.295C.082.263.046.23 0 .19",
    mask: "url(#5l5kp3dnhb)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.b057fb0b.svg";
export { ForwardRef as ReactComponent };